/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { firstValueFrom } from "rxjs";

import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ApiConfiguration } from "../api-configuration";
import { BaseService } from "../base-service";
import { getApplicationHealth } from "../fn/health/get-application-health";
import { GetApplicationHealth$Params } from "../fn/health/get-application-health";
import { getNetworkHealthByServiceId } from "../fn/health/get-network-health-by-service-id";
import { GetNetworkHealthByServiceId$Params } from "../fn/health/get-network-health-by-service-id";
import { HealthRecord } from "../models/health-record";
import { StrictHttpResponse } from "../strict-http-response";

/**
 * Health endpoints indicate whether a service is healthy right now; this is live data.
 *
 * The non-wireless health endpoint used to be `/health/{subscription_id}/{subscription_instance_id}`. The subscription id was only used for Firewall subscriptions to get which SAPs (subscription instance ids) were related to it, so is otherwise unnecessary. In non-firewall cases, the submitted instance id was used to query Influx with.
 *
 * To allow getting the health of 1 or more SAPs, subscription instance ids are now sent via query parameters, e.g.`?instance_ids=...&instance_ids=...`.
 *
 * The health information for Wireless services is not by subscription id, but by the vendor+location information. This endpoint is designed assuming we are not changing that. See main wireless health endpoint for details.
 */
@Injectable({ providedIn: "root" })
export class HealthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getNetworkHealthByServiceId()` */
  static readonly GetNetworkHealthByServiceIdPath = "/stats/services/{subscription_id}/health";

  /**
   * Get Network Health By Service Id.
   *
   * Get network health by subscription_id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNetworkHealthByServiceId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNetworkHealthByServiceId$Response(
    params: GetNetworkHealthByServiceId$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<HealthRecord>> {
    const obs = getNetworkHealthByServiceId(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Network Health By Service Id.
   *
   * Get network health by subscription_id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNetworkHealthByServiceId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNetworkHealthByServiceId(
    params: GetNetworkHealthByServiceId$Params,
    context?: HttpContext,
  ): Promise<HealthRecord> {
    const resp = this.getNetworkHealthByServiceId$Response(params, context);
    return resp.then((r: StrictHttpResponse<HealthRecord>): HealthRecord => r.body);
  }

  /** Path part for operation `getApplicationHealth()` */
  static readonly GetApplicationHealthPath = "/stats/health";

  /**
   * Get Application Health.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApplicationHealth()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApplicationHealth$Response(
    params?: GetApplicationHealth$Params,
    context?: HttpContext,
  ): Promise<
    StrictHttpResponse<{
      [key: string]: string;
    }>
  > {
    const obs = getApplicationHealth(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Application Health.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApplicationHealth$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApplicationHealth(
    params?: GetApplicationHealth$Params,
    context?: HttpContext,
  ): Promise<{
    [key: string]: string;
  }> {
    const resp = this.getApplicationHealth$Response(params, context);
    return resp.then(
      (
        r: StrictHttpResponse<{
          [key: string]: string;
        }>,
      ): {
        [key: string]: string;
      } => r.body,
    );
  }
}
